'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNINITIALIZED = exports.UNINITIALIZED = 'UNINITIALIZED';
var PENDING = exports.PENDING = 'PENDING';
var SUCCEEDED = exports.SUCCEEDED = 'SUCCEEDED';
var FAILED = exports.FAILED = 'FAILED';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/RequestStatusTypes.js
// module id = 84
// module chunks = 2 3